import { Box, Text } from '@factorialco/deprecated-design-system'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { APPROVED, REJECTED } from 'modules/approvals/lib/materializedApprovalFlows'

interface ContentProps {
  status: string
  finalDecisionAt: string
}

export const FinalDecision = ({ status, finalDecisionAt }: ContentProps) => {
  if ([APPROVED, REJECTED].includes(status)) {
    const translatedStatus =
      status === APPROVED
        ? i18n.t('settings.approvals.approval_request_view.approval_history.approved')
        : i18n.t('settings.approvals.approval_request_view.approval_history.rejected')

    return (
      <Box
        padding="s16"
        border={{
          top: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        gap="s24"
      >
        <Text.Normal size="200">
          {translatedStatus}: {dateBackendDateTimeToUI(finalDecisionAt)}
        </Text.Normal>
      </Box>
    )
  }

  return null
}
